export interface WicketTokenData {
  id_token: string; // Token used for authorization header
  refresh_token: string;
  cognito_sub?: string;
  email?: string;
  token?: string;
}

export interface WicketTokens {
  token_type: 'Bearer';
  id_token: string;
  access_token: string;
  refresh_token: string;
}
